export const environment = {
    baseUrl: 'https://uat.adviserportal.pias.sg:9099',
    apis: {
        login: '/v2/pias/login',
        logout: '/v1/pias/user/logout',
        dashboardInceptedApe: '/v2/pias/dashboard-ape',
        dashboardGrossRevenue: '/v2/pias/dashboard-grossrevenue',
        dashboardPiasConvention: '/v2/pias/dashboard-convention',
        dashboardMdrtStatus: '/v2/pias/dashboard-mdrt',
        dashboardBranchwiseadvisors: '/v2/pias/branchwiseagent',
        dashboardInceptedApeDirectorwiseManagers: '/v2/pias/directorwisemanager',
        dashboardInceptedApeManagerwiseAdvisors: '/v2/pias/managerwiseagent',
        dashboardGrossRevenueDirectorwiseManagers: '/v2/pias/dashboard-grossrevenue/directorwisemanager',
        dashboardGrossRevenueManagerwiseAdvisors: '/v2/pias/dashboard-grossrevenue/managerwiseagent',
        getDownloadResourcelist: '/v1/pias/user/downloadresource',
        userLogDocument: '/v2/pias/user-log-document',
        getUserList: '/v1/pias/user/userlist',
        createNewUser: '/v1/pias/user/createuser',
        registerUser: '/v2/pias/registeration',
        verifyEmailOtp: '/v2/pias/emailverify',
        resendEmailOtp: '/v2/pias/resentotp',
        changeUserPassword: '/v2/pias/updatepassword',
        verifyForgotPasswordOtp: '/v2/pias/forgotpassword',
        updateForgotPassword: '/v2/pias/confirmforgotpassword',
        constants: '/v2/pias/constants'
    }
};
